<template>
    <b-container>
        <b-form>
            <b-form-row>
                <b-form-group label-for="file-upload-input"
                              label="Εισαγωγή αρχείου"
                              content-cols="12"
                >
                    <b-form-file
                        id="file-upload-input"
                        v-model="selectedFile"
                        :state="fileValidation"
                        placeholder="Επιλέξτε αρχείο zip"
                        drop-placeholder="Αφήστε το αρχείο εδώ."
                        accept=".zip"
                    ></b-form-file>
                </b-form-group>
            </b-form-row>
            <b-form-row>
                <b-form-group label="Τύπος εισαγωγής"
                              label-for="import-type-input"
                              content-cols="12"
                >
                    <b-form-select id="import-type-input"
                                   :state="importTypeValidattion"
                                   v-model="selectedImportType"
                                   :options="importTypes"
                                   value-field="typeKwd"
                                   text-field="typeLek"
                    ></b-form-select>
                </b-form-group>
            </b-form-row>
        </b-form>
        <b-progress v-if="showProgress" :value="progressValue" :max="100" show-progress animated/>
    </b-container>
</template>

<script>

export default {
    name: "DiavImportUpload",
    event: ['upload:error', 'upload:success'],
    components: {},
    props: {},
    data() {
        return {
            selectedFile: null,
            selectedImportType: null,
            importTypes: [],
            showProgress: false,
            progressValue: 0
        }
    },
    mounted() {
        this.fetchImportTypes();
    },
    computed: {
        valid() {
            return this.fileValidation && this.importTypeValidattion
        },
        fileValidation() {
            return this.selectedFile != null;
        },
        importTypeValidattion() {
            return this.selectedImportType != null && this.importTypes.map(x => x.typeKwd).includes(this.selectedImportType);
        },
        role: function () {
            return this.$store.getters.userRole;
        },
    },
    methods: {
        checkActiveImportAsync() {
            return this.$http.get(`/diav/imports/active`)
        },
        upload: function () {
            let ref = this;
            if (!this.valid) {
                return
            }

            this.checkActiveImportAsync().then((response) => {
                let data = response.data.responseData.content
                if (data.length !== 0) {
                    ref.$emit("upload:error", "Δε μπορείτε να ξεκινήσετε καινουργία εισαγωγή καθώς υπάρχει ήδη μια ενεργή.")
                    return;
                }

                this.showProgress = true;
                /*
                    Initialize the form data
                */
                let formData = new FormData();

                /*
                    Add the form data we need to submit
                */
                formData.append('file', this.selectedFile);
                this.$http.post(`/diav/imports/upload?type=${this.selectedImportType}`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                        onUploadProgress: function (progressEvent) {
                            this.progressValue = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
                        }.bind(this)
                    }
                ).then(function () {
                    ref.$emit("upload:success")
                })
                    .catch((e) => {
                        let resp = e.response;
                        console.log(resp)
                        ref.$emit("upload:error", "Υπήρξε κάποιο πρόβλημα κατα το ανέβασμα του αρχείου.")
                    });
            })

        },
        fetchImportTypes: function () {
            this.$store.dispatch('loading');
            this.$http.get("/diav/imports/types/list")
                .then((response) => {
                    let resp = response.data;
                    this.importTypes = resp.responseData;
                    this.$store.dispatch('stop_loading');
                })
                .catch((e) => {
                    console.error(e);
                    this.$store.dispatch('stop_loading');
                });
        }
    }
}
</script>

<style scoped></style>